module.exports = __webpack_public_path__ + "static/media/datos electorales_b-01.c2c80c38.svg";